import React from "react";
import { connect } from 'react-redux'
import Switch from "../../../components/Switch";
import { switchDebugOption } from "../../../redux/actions/DeploymentActions";
import styles from './DeploymentDebug.module.scss'
import CardAdvanced from "../../../components/card/CardAdvanced";
import { CardItem } from "../../../components/card/Card";
import Button from "../../../components/ripple/Button";
import { LOCAL_STORAGE_NAME_BUILDER_PROJECTS } from "../../../settings/content/deploymentStacker";

function DeploymentDebug({dispatch, debug, bodyStack, bodyBuilder, custom}) {
    return (
        <CardAdvanced
            className={styles['debug']}
            title={
                <div className={styles['debug__header']}>
                    <i className={`fas fa-code ${styles['debug__header__icon']}`}/>
                    <p className={styles['debug__header__title']}>DEBUG</p>
                </div>
            }
            id='deployment-debug'
            // darker={!!custom}
        >
            <CardItem style={{padding: 0}}>
                <Button
                    className='card-button'
                    iconLeft='fas fa-code'
                    title={`Log request body`}
                    displayType='text'
                    onClick={() => console.log(bodyStack)}
                />
            </CardItem>
            {
                !!custom &&
                <>
                    <CardItem style={{padding: 0}}>
                        <Button
                            className='card-button'
                            iconLeft='fas fa-code'
                            title={`Log custom request body`}
                            displayType='text'
                            onClick={() => console.log(bodyBuilder)}
                        />
                    </CardItem>
                    <CardItem style={{padding: 0}}>
                        <Button
                            className='card-button'
                            iconLeft='fas fa-redo'
                            title={`Clear custom deployment local storage data and reload`}
                            displayType='text'
                            onClick={() => {
                                localStorage.removeItem(LOCAL_STORAGE_NAME_BUILDER_PROJECTS);
                                // localStorage.removeItem('custom_deployment_id');
                                window.location.reload();
                            }}
                        />
                    </CardItem>
                    <CardItem style={{padding: 0}}>
                        <Button
                            className='card-button'
                            iconLeft='fas fa-times'
                            title={`Clear custom deployment local storage data`}
                            displayType='text'
                            onClick={() => {
                                localStorage.removeItem(LOCAL_STORAGE_NAME_BUILDER_PROJECTS);
                                // localStorage.removeItem('custom_deployment_id');
                            }}
                        />
                    </CardItem>
                </>
            }
            <CardItem>
                <Switch
                    className={styles['debug__container__switch']}
                    title='Disable onsubmit frontend domain and provider fields validation'
                    description='Allows to check how backend handles errors'
                    onChange={bool => dispatch(switchDebugOption({disableFieldsOnsubmitValidation: bool}))}
                    value={!!debug.disableFieldsOnsubmitValidation}
                />
            </CardItem>
            <CardItem>
                <Switch
                    className={styles['debug__container__switch']}
                    title='Disable deployment validation'
                    description='Triggers direct request to /init without /pre-check. Allows to test how /init returns errors'
                    onChange={bool => dispatch(switchDebugOption({disablePreCheck: bool}))}
                    value={!!debug.disablePreCheck}
                />
            </CardItem>
            <CardItem>
                <Switch
                    className={styles['debug__container__switch']}
                    title='Disable payment validation by frontend'
                    description='Force ignore frontend payment validation. Allows to test how backend (/init) handles payment.'
                    onChange={bool => dispatch(switchDebugOption({disableFrontendPaymentValidation: bool}))}
                    value={!!debug.disableFrontendPaymentValidation}
                />
            </CardItem>
            <CardItem>
                <Switch
                    className={styles['debug__container__switch']}
                    title='Remove "provider" prop from request body'
                    description='Removes prop to test endpoint errors'
                    onChange={bool => dispatch(switchDebugOption({removeProvider: bool}))}
                    value={!!debug.removeProvider}
                />
            </CardItem>
            <CardItem>
                <Switch
                    className={styles['debug__container__switch']}
                    title='Remove "stack_code" prop from request body'
                    description='Removes prop to test endpoint errors'
                    onChange={bool => dispatch(switchDebugOption({removeStackCode: bool}))}
                    value={!!debug.removeStackCode}
                />
            </CardItem>
            <CardItem>
                <Switch
                    className={styles['debug__container__switch']}
                    title='Remove "selected_plan" prop from request body'
                    description='Removes prop to test endpoint errors'
                    onChange={bool => dispatch(switchDebugOption({removeSelectedPlan: bool}))}
                    value={!!debug.removeSelectedPlan}
                />
            </CardItem>
        </CardAdvanced>
    )
}

const mapStateToProps = state => ({
    debug: state.deployment.debug,
    bodyStack: state.deployment.bodyStack,
    bodyBuilder: state.deployment.bodyBuilder,
});

export default connect(mapStateToProps)(DeploymentDebug)